import React, { FC, useEffect, useImperativeHandle } from "react";
import { Form } from "antd";
import { __FormItemsBox as FormItemsBox } from "./FormItemsBox";
import { IYhFormBox } from "./Types";


export const __FormBox: FC<IYhFormBox> = ({ formRef, boxs, ...props }) => {
    const [form] = Form.useForm();
    const { labelCol, disabled, formValues, onChange, onFinish } = props
    const onValuesChange = (changedValues: any, values: any) => {
        // disabled ? form.setFieldsValue(formValues) : onChange?.(changedValues);
        onChange?.(changedValues);
    }
    useEffect(() => {
        form.setFieldsValue(formValues);
    }, [formValues, form]);

    useImperativeHandle(formRef, () => ({
        validateFields: async () => {
            return await form.validateFields();
        },
        getFieldsValue: () => {
            return form.getFieldsValue()
        },
        setFieldsValue: (formValues) => {
            form.setFieldsValue(formValues);
        },
        resetFields: form.resetFields,
        inst: () => {
            return form;
        }
    }));
    return <Form
        form={form}
        onValuesChange={onValuesChange}
        labelCol={labelCol}
        onFinish={onFinish}
    >
        {
            boxs.map((el, index) => <FormItemsBox key={index} {...el} disabled={el.disabled ?? disabled} />)
        }
        {
            props.children
        }
    </Form>
}
